export const WORK_MODES = ["On-site", "Remote", "Business Travel"];

export const LOCATION_STATUS = {
  OFFICE: "office",
  HOME: "home",
  BUSINESS_TRAVEL: "business_travel",
  OTHER: "other",
  UNKNOWN: "unknown",
};

export const LOCATION_WAIT_MS = 6000;
const GEOLOCATION_OPTIONS = { enableHighAccuracy: false, timeout: 5000, maximumAge: 120000 };

let pendingPosition = null;
export const getCurrentPosition = () => {
  if (typeof navigator === "undefined" || !navigator.geolocation) return Promise.resolve(null);
  if (pendingPosition) return pendingPosition;

  pendingPosition = new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), LOCATION_WAIT_MS);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        clearTimeout(timer);
        resolve({
          location: `${coords.latitude},${coords.longitude}`,
          accuracy: Math.round(coords.accuracy),
        });
      },
      () => {
        clearTimeout(timer);
        resolve(null);
      },
      GEOLOCATION_OPTIONS,
    );
  }).finally(() => {
    pendingPosition = null;
  });
  return pendingPosition;
};

export const defaultWorkMode = (shift, user) => {
  if (shift?.flexibility === "Remote") return "Remote";
  if (shift?.flexibility === "On-site") return "On-site";
  return user?.remote ? "Remote" : "On-site";
};

export const LOCATION_STATUS_STYLES = {
  office: { bg: "rgba(16, 185, 129, 0.1)", color: "#047857" },
  home: { bg: "rgba(16, 185, 129, 0.1)", color: "#047857" },
  business_travel: { bg: "rgba(59, 130, 246, 0.1)", color: "#1d4ed8" },
  other: { bg: "rgba(234, 179, 8, 0.15)", color: "#92400e" },
  unknown: { bg: "var(--gray-100)", color: "var(--text-subtle)" },
};

export const formatDistance = (meters) => {
  const rounded = Math.round(meters);
  return rounded >= 1000 ? `${(rounded / 1000).toFixed(1)} km` : `${rounded} m`;
};
